import { Box } from "@mui/material";
// import DataSource from "devextreme/data/data_source";
import type DataSource from "devextreme/data/data_source";
import { useMemo, useRef } from "react";
import type {
  ChartStyleSettings,
  DimensionField,
  PivotRowResponse,
  PreviewMode,
  ReportField,
  ValueCell,
} from "../../../../../../../api/types/svTypes.ts";
import { ReportType } from "../../../../../../../api/types/svTypes.ts";
import useResizeObserver from "../../../hooks/resizeObserver.ts";
import { PreviewDefaultSize } from "../../../utilities/const.ts";
import Area from "./Chart.Area.tsx";
import Bar from "./Chart.Bar.tsx";
import Doughnut from "./Chart.Doughnut.tsx";
import Line from "./Chart.Line.tsx";
import Pie from "./Chart.Pie.tsx";
import TreeMap from "./Chart.TreeMap.tsx";
import type { ExportChartFormats } from "./ChartProps.ts";

interface Props {
  type: ReportType;
  data: PivotRowResponse[];
  dataSource: DataSource;
  args: DimensionField[];
  values: ReportField[];
  settings: ChartStyleSettings;
  exportFunc: (callback?: (fileName: string, format: ExportChartFormats) => void) => void;
  onDrillDown: ((field: ReportField, value: ValueCell) => void) | undefined;
  previewMode: PreviewMode;
}

export default function Chart(props: Props) {
  const maxHeight = useMemo(() => (props.previewMode === "maximize" ? undefined : 600), [props.previewMode]);
  const maxWidth = useMemo(
    () => (props.previewMode === "maximize" ? undefined : PreviewDefaultSize),
    [props.previewMode]
  );

  const divRef = useRef<HTMLDivElement>(null);
  const size = useResizeObserver(divRef, maxHeight, maxWidth);

  const renderChart = () => {
    if (props.type === ReportType.PieChart) {
      return <Pie {...props} size={size} />;
    } else if (props.type === ReportType.BarChart) {
      return <Bar {...props} size={size} />;
    } else if (props.type === ReportType.LineChart) {
      return <Line {...props} size={size} />;
    } else if (props.type === ReportType.AreaChart) {
      return <Area {...props} size={size} />;
    } else if (props.type === ReportType.DoughnutChart) {
      return <Doughnut {...props} size={size} />;
    } else if (props.type === ReportType.TreeMapChart) {
      return <TreeMap {...props} size={size} />;
    }
    return <>Chart Type not supported yet</>;
  };
  return (
    <Box
      component="div"
      ref={divRef}
      sx={{ display: "flex", flex: 1, justifyContent: "center", alignItems: "center", position: "relative" }}
    >
      <Box
        sx={{
          display: "flex",
          flex: 1,
          position: "absolute",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {renderChart()}
      </Box>
    </Box>
  );
}
